import type ProjectReport from "../../../models/domain/project_report";
import type { AvvirEvent } from "type_aliases";

export type ProjectReportUpdatedEvent = AvvirEvent<typeof PROJECT_REPORT_UPDATED, {projectId: string, report: ProjectReport}>

const projectReportUpdated = (projectId: string, projectReport : ProjectReport): ProjectReportUpdatedEvent => ({
  type: PROJECT_REPORT_UPDATED,
  payload: {
    projectId,
    report: projectReport
  }
});

export const PROJECT_REPORT_UPDATED = "project_report_updated";

export default projectReportUpdated;
